var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:[_vm.imageState],style:(_vm.computedStyle),attrs:{"data-state":_vm.imageState}},[(_vm.drm && !_vm.drmActive)?_c('figcaption',[_c('p',[_vm._v(" "+_vm._s(_vm.$t("settings.not_active_movie"))+" "),_c('router-link',{staticClass:"info",attrs:{"to":"/help"}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }